import { ZigzagEvent } from '@common/log-manager';

export const useEpickStylelistUBL = () => {
  const pageviewEpickStylelist = (product_id: string, post_id: string) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'image',
      object_section: 'epick',
      object_id: post_id,
      data: JSON.stringify({ product_id }),
    });
  };

  const clickEpickStylelistItem = (product_id: string, post_id: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'image',
      object_section: 'epick',
      object_id: post_id,
      data: JSON.stringify({ product_id }),
    });
  };

  return {
    pageviewEpickStylelist,
    clickEpickStylelistItem,
  };
};
